<template>
  <div class="card is-width-640px pa-20">
    <div class="card-title has-text-justified">
      <p class="has-text-grid-1 has-text-weight-bold is-size-6">
        {{$t('general.societe.titleModal')}}
      </p>
    </div>
    <div class="card-content px-0">
      <societe-selector :isReadonly="false"></societe-selector>
    </div>
    <div class="has-text-centered mt-10">
      <b-button
        type="is-transparent"
        class="has-text-default"
        @click="$parent.close()">
        {{$t('general.btnAnnuler')}}
      </b-button>
      <b-tooltip
        :active="!societeActiveId"
        position="is-left"
        :label="$t('general.societe.msgInfo')"
        type="is-danger">
        <b-button
          type="is-primary"
          class="has-text-weight-bold ml-20"
          @click="$emit('isSelected')"
          :disabled="!societeActiveId">
          {{$t('general.btnContinuer')}}
        </b-button>
      </b-tooltip>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import SocieteSelector from '@/components/general/societeSelector';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'modalSociete',
  components: {
    SocieteSelector,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
};
</script>

<style>

</style>
